import { useId } from "react";

import { useMbcRequestSettings } from "../hooks/useMbcRequestSettings";
import { SegmentedRadioGroup } from "./SegmentedRadioGroup";
import { SidebarCard } from "./SidebarCard";

type AiImagesCardProps = {
  requestId: null | number;
};

const OPTIONS = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export function AiImagesCard({ requestId }: AiImagesCardProps) {
  const questionId = useId();
  const { isLoading, restrictAiAssets, save } =
    useMbcRequestSettings(requestId);

  return (
    <SidebarCard className="px-6 py-5">
      <h2 className="text-base font-bold text-text-primary" id={questionId}>
        Are AI-generated images OK in your designs?
      </h2>
      <SegmentedRadioGroup
        isDisabled={isLoading || restrictAiAssets === undefined}
        labelledBy={questionId}
        onChange={(value) => save({ restrictAiAssets: value === "no" })}
        options={OPTIONS}
        value={restrictAiAssets ? "no" : "yes"}
      />
    </SidebarCard>
  );
}
